export default {
  props: [
    {
      attr: 'courseName',
      name: '课程名称'
    },
    {
      attr: 'status',
      name: '课程状态',
      slot: 'status'
    },
    {
      attr: 'courseType',
      name: '课程类型',
      slot: 'courseType'
    },
    {
      attr: 'timeDes',
      name: '上课时间',
      slot: 'timeDes'
    },
    {
      attr: 'teacher',
      name: '主讲老师',
      slot: 'teacher'
    },
    {
      attr: 'lessonQty',
      name: '课时数'
    },
    {
      attr: 'boughtQty',
      name: '学生数'
    }
  ]
}
